import React from 'react';
import { Users, Globe, Bell, Shield } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const ForParentsSchools = () => {
  const features = [
    {
      icon: Users,
      title: 'Multiple Child Profiles',
      description: 'Set up individual learners with separate avatars, preferences, and progress history.',
      color: '#4CAF50',
    },
    {
      icon: Globe,
      title: 'Languages and Voices',
      description: 'Match the learning experience to each child with flexible language and narrator settings.',
      color: '#2196F3',
    },
    {
      icon: Bell,
      title: 'Learning Reminders',
      description: 'Use reminders and streak nudges to support a regular, low-pressure learning habit.',
      color: '#FFD700',
    },
    {
      icon: Shield,
      title: 'Guardian Controls',
      description: 'Protect adult-only areas, manage settings safely, and keep account and data controls accessible.',
      color: '#FF7F30',
    },
  ];

  return (
    <section id="for-families" className="py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-left sm:text-center mb-8 sm:mb-16 space-y-4">
          <div className="inline-block px-4 py-2 bg-[#FFF3E0] rounded-full border border-[#FFE0B2]">
            <span className="text-[#FF7F30] font-semibold text-sm tracking-wide">Made for Real Life</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#333333] leading-[1.05] sm:leading-tight lg:leading-[1.1]">
            Made for Families.
            <span className="block text-[#FF7F30]">Ready for Language Schools.</span>
          </h2>
          <p className="text-lg sm:text-xl text-[#666666] max-w-3xl mx-auto leading-relaxed">
            LinguPix feels simple for children, but gives parents, guardians, and educators the consistency, visibility, and control they need.
          </p>
          <p className="text-lg sm:text-xl font-bold text-[#333333] max-w-3xl mx-auto leading-relaxed">
            From home practice to between-class reinforcement, LinguPix fits different learning routines without adding complexity.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="border-none shadow-none"
              style={{ backgroundColor: `${feature.color}20`, animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="p-6 space-y-4 flex flex-col h-full">
                <div className="shrink-0 mb-1">
                  <feature.icon size={32} style={{ color: feature.color }} />
                </div>
                <h3 className="text-xl font-bold text-[#333333]">{feature.title}</h3>
                <p className="text-[#666666] leading-relaxed flex-grow">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ForParentsSchools;
